
export type TrendMarkProp = "equal"|"up"|"down"

const TrendMark = ({trend, difference}:{trend:TrendMarkProp, difference:number}) => {
    let markColor = ""
    if (difference === 0) {
        markColor = "border-ui-report-high-severity"
    } else if (difference >= 0.4) {
        markColor = "border-ui-report-high-severity"
    } else if (difference >= 0.3) {
        markColor = "border-ui-report-medium-severity"
    } else if (difference >= 0.2) {
        markColor = "border-ui-report-yellow"
    } else if (difference >= 0.1) {
        markColor = "border-ui-report-low-severity"
    } else {
        markColor = "border-b-gray-500"
    }
    
    return (
        <div>
            {{
                "equal":
                <div className="text-center text-neutral-900 text-sm items-center justify-center">--</div>,
                "up":
                <div className={`w-fit border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] ${markColor}`} />,
                "down":
                <div className="border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-ui-report-low-severity" />
                }[trend]
            }
        </div>
    )
}

export default TrendMark